export type OrderByType = 'name' | 'userName' | 'email' | 'country' | 'phoneNumber' | 'status' | 'id';

export enum SortOrderEnum {
  DESC = 'desc',
  ASC = 'asc',
}
